/* global $: false */

/**
 *  Fixed Navbar on scroll
 */
$( document ).ready(function() {
	'use strict';

	let $fixedNavbar  = $('.fixed-navbar');
	let $wrapperNavbar  = $('.wrapper-navbar');
	if ($fixedNavbar.length > 0 && window.innerWidth > 1200) {
		let $wrapperNavbarHeight = ($wrapperNavbar.length) ? $wrapperNavbar.height() : 0;
		let fixedNavbarPosition = $fixedNavbar.position().top - $wrapperNavbarHeight;
		$(window).on('scroll', function() {
			if ($( this ).scrollTop() > fixedNavbarPosition) {
				$fixedNavbar.addClass('fixed-top');
			} else {
				$fixedNavbar.removeClass('fixed-top');
			}
		});
	}
});
